export const call_types = {
  inbound: 1,
  outbound: 2
}
